import { useState, useRef, useCallback } from "react";
import { IconStarBurst } from "@/components/ui/cartoon-icons";
import { cn } from "@/lib/utils";

function Loader() {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-[#ece7f8] z-10">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#b8a5f0]/20 blur-[20px] animate-pulse-glow" style={{ width: 56, height: 56, margin: "-8px" }} />
        <div className="size-10 rounded-full bg-[#241d3a]/[0.06] border border-[#241d3a]/15 flex items-center justify-center animate-pulse-ring">
          <IconStarBurst className="size-4 text-[#7c5cf0] animate-float" />
        </div>
      </div>
    </div>
  );
}

interface VideoWithLoaderProps {
  src: string;
  className?: string;
  wrapperClassName?: string;
  controls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  playsInline?: boolean;
  muted?: boolean;
  preload?: string;
  style?: React.CSSProperties;
  onPointerEnter?: React.PointerEventHandler<HTMLVideoElement>;
  onPointerLeave?: React.PointerEventHandler<HTMLVideoElement>;
  onClick?: React.MouseEventHandler<HTMLVideoElement>;
}

export function VideoWithLoader({
  src,
  className,
  wrapperClassName,
  controls,
  autoPlay,
  loop,
  playsInline,
  muted,
  preload,
  style,
  onPointerEnter,
  onPointerLeave,
  onClick,
}: VideoWithLoaderProps) {
  const [loading, setLoading] = useState(true);
  const ref = useRef<HTMLVideoElement>(null);

  const handleReady = useCallback(() => setLoading(false), []);

  return (
    <div className={cn("relative w-full h-full", loading && "min-h-[120px]", wrapperClassName)}>
      {loading && <Loader />}
      <video
        ref={ref}
        src={src}
        className={className}
        controls={controls}
        autoPlay={autoPlay}
        loop={loop}
        playsInline={playsInline}
        muted={muted}
        preload={preload}
        style={style}
        onCanPlay={handleReady}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        onClick={onClick}
      />
    </div>
  );
}
